import React from 'react';
import { StyledTimerText } from './styledComponents';

export default function DefaultText({ style, string, className }) {
  return (
    <StyledTimerText style={style} className={className}>
      {string}
    </StyledTimerText>
  );
}

